// Эффекты: конфетти-кубики, пыль, кольцо перфекта, вертолёт с баннером.
// Всё из пула — на слабых телефонах без аллокаций в кадре.
import * as THREE from 'three';
import { COLORS } from './scene.mjs';

const POOL_SIZE = 140;

export function createFx(scene) {
  // --- Пул частиц (кубики: и конфетти, и пыль) ---
  const particleGeom = new THREE.BoxGeometry(0.14, 0.14, 0.14);
  // Золото и салют светятся в bloom: emissive выше единицы проходит порог,
  // обычные материалы (белый = 1.0) остаются без ореола
  const goldMat = new THREE.MeshLambertMaterial({ color: 0xffc93c });
  goldMat.emissive.setRGB(1.5, 0.95, 0.15);
  const sparkMat = new THREE.MeshLambertMaterial({ color: 0xffffff });
  sparkMat.emissive.setRGB(1.2, 1.2, 1.3);
  const materials = {
    red: new THREE.MeshLambertMaterial({ color: COLORS.red }),
    white: sparkMat,
    gold: goldMat,
    dust: new THREE.MeshLambertMaterial({ color: 0xcfc9bd, transparent: true }),
  };
  const pool = [];
  for (let i = 0; i < POOL_SIZE; i++) {
    const m = new THREE.Mesh(particleGeom, materials.red);
    m.visible = false;
    scene.add(m);
    pool.push({ mesh: m, vel: new THREE.Vector3(), spin: new THREE.Vector3(), life: 0, maxLife: 1, gravity: 1 });
  }

  function spawn(pos, mat, count, speed, up, gravity, life) {
    let spawned = 0;
    for (const p of pool) {
      if (p.life > 0) continue;
      p.mesh.material = mat;
      p.mesh.visible = true;
      p.mesh.position.copy(pos);
      p.mesh.scale.setScalar(0.7 + Math.random() * 0.8);
      p.vel.set(
        (Math.random() - 0.5) * speed,
        up * (0.5 + Math.random() * 0.8),
        (Math.random() - 0.5) * speed
      );
      p.spin.set(Math.random() * 8, Math.random() * 8, Math.random() * 8);
      p.life = p.maxLife = life * (0.7 + Math.random() * 0.6);
      p.gravity = gravity;
      if (++spawned >= count) break;
    }
  }

  // --- Кольцо перфекта ---
  const ringGeom = new THREE.RingGeometry(0.5, 0.72, 32);
  const ringMat = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide });
  ringMat.color.setRGB(3, 2.1, 0.6); // ярче белого — только оно и ловится bloom'ом
  const ring = new THREE.Mesh(ringGeom, ringMat);
  ring.visible = false;
  scene.add(ring);
  let ringLife = 0;

  // --- Ударная волна hit-stop'а: широкое кольцо, расходится резче и дальше ---
  const shockMat = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide });
  shockMat.color.setRGB(2.2, 2.2, 2.6); // холодная вспышка, ловится bloom'ом
  const shock = new THREE.Mesh(new THREE.RingGeometry(0.86, 1.0, 40), shockMat);
  shock.visible = false;
  scene.add(shock);
  let shockLife = 0;

  // --- Вертолёт с баннером «ЭТАЖИ» (комбо 10) ---
  const heli = buildHelicopter();
  heli.group.visible = false;
  scene.add(heli.group);
  let heliT = -1; // прогресс полёта 0..1, -1 = не летит
  let heliY = 20;

  function buildHelicopter() {
    const g = new THREE.Group();
    const body = new THREE.Mesh(new THREE.BoxGeometry(1.6, 0.8, 0.8), new THREE.MeshLambertMaterial({ color: COLORS.red }));
    body.castShadow = true;
    g.add(body);
    const glass = new THREE.Mesh(new THREE.BoxGeometry(0.5, 0.5, 0.82), new THREE.MeshLambertMaterial({ color: 0x9fd8f5 }));
    glass.position.set(0.6, 0.1, 0);
    g.add(glass);
    const tail = new THREE.Mesh(new THREE.BoxGeometry(1.4, 0.22, 0.22), new THREE.MeshLambertMaterial({ color: COLORS.dark }));
    tail.position.set(-1.4, 0.15, 0);
    g.add(tail);
    const rotor = new THREE.Mesh(new THREE.BoxGeometry(2.6, 0.06, 0.16), new THREE.MeshLambertMaterial({ color: COLORS.dark }));
    rotor.position.set(0, 0.55, 0);
    g.add(rotor);

    // Баннер: канвас с надписью, тянется за хвостом
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 64;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, 256, 64);
    ctx.strokeStyle = '#e2231a';
    ctx.lineWidth = 6;
    ctx.strokeRect(3, 3, 250, 58);
    ctx.fillStyle = '#e2231a';
    ctx.font = 'bold 40px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('ЭТАЖИ', 128, 34);
    const tex = new THREE.CanvasTexture(canvas);
    tex.colorSpace = THREE.SRGBColorSpace;
    const banner = new THREE.Mesh(
      new THREE.PlaneGeometry(3.4, 0.85),
      new THREE.MeshBasicMaterial({ map: tex, side: THREE.DoubleSide })
    );
    banner.position.set(-3.6, -0.1, 0);
    g.add(banner);
    return { group: g, rotor, banner };
  }

  return {
    // Перфект: кольцо + золотое конфетти
    perfectBurst(pos) {
      ring.position.set(pos.x, pos.y, pos.z + 1.8);
      ring.scale.setScalar(0.4);
      ring.material.opacity = 0.95;
      ring.visible = true;
      ringLife = 0.5;
      spawn(pos, materials.gold, 14, 4, 4, 9, 0.9);
    },

    // Радиальная волна от точки посадки — партнёр hit-stop'а (один квад)
    shockwave(pos) {
      shock.position.set(pos.x, pos.y, pos.z + 1.9);
      shock.scale.setScalar(0.3);
      shock.material.opacity = 0.9;
      shock.visible = true;
      shockLife = 0.36;
    },

    // Обычная посадка: пыль из-под блока
    dust(pos, width) {
      const p = pos.clone();
      p.x -= width / 2;
      spawn(p, materials.dust, 5, 1.6, 1.2, 4, 0.5);
      p.x += width;
      spawn(p, materials.dust, 5, 1.6, 1.2, 4, 0.5);
    },

    // Салют (комбо 5 и победа)
    celebration(pos) {
      spawn(pos, materials.red, 18, 7, 6, 7, 1.4);
      spawn(pos, materials.white, 18, 7, 6, 7, 1.4);
      spawn(pos, materials.gold, 18, 7, 6, 7, 1.4);
    },

    // Запуск вертолёта на высоте чуть выше точки pos
    helicopterFly(topY) {
      heliT = 0;
      heliY = topY + 6;
      heli.group.visible = true;
    },

    update(dt, elapsed) {
      for (const p of pool) {
        if (p.life <= 0) continue;
        p.life -= dt;
        if (p.life <= 0) { p.mesh.visible = false; continue; }
        p.vel.y -= p.gravity * dt;
        p.mesh.position.addScaledVector(p.vel, dt);
        p.mesh.rotation.x += p.spin.x * dt;
        p.mesh.rotation.y += p.spin.y * dt;
        if (p.mesh.material.transparent) p.mesh.material.opacity = p.life / p.maxLife;
      }

      if (ringLife > 0) {
        ringLife -= dt;
        ring.scale.addScalar(dt * 6);
        ring.material.opacity = Math.max(0, ringLife * 2);
        if (ringLife <= 0) ring.visible = false;
      }

      if (shockLife > 0) {
        shockLife -= dt;
        shock.scale.addScalar(dt * 26); // волна убегает заметно быстрее кольца
        shock.material.opacity = Math.max(0, shockLife * 2.8);
        if (shockLife <= 0) shock.visible = false;
      }

      if (heliT >= 0) {
        heliT += dt / 6; // весь пролёт — 6 секунд
        const x = -32 + heliT * 64;
        heli.group.position.set(x, heliY + Math.sin(elapsed * 2) * 0.4, -7);
        heli.rotor.rotation.y = elapsed * 40;
        heli.banner.rotation.z = Math.sin(elapsed * 3) * 0.06;
        if (heliT >= 1) {
          heliT = -1;
          heli.group.visible = false;
        }
      }
    },
  };
}
